import type { NormalizedBox } from "@users/staffPhotoClient";
import { useState } from "react";

import { BoxOverlay } from "./BoxOverlay";
import { fromNormalized, type SourceSize, toNormalized } from "./fixtureBoxes";
import type { RoomStill } from "./perceptionClient";
import { StillFrame } from "./StillFrame";

/**
 * A still to draw one person's box on. The box is held as fractions of the
 * still's width and height, which is what brian's capture takes, so it does not
 * depend on the pixel size the image loaded at.
 */
export const StillBoxEditor = ({
  still,
  box,
  disabled,
  onChange,
}: {
  still: RoomStill;
  box: NormalizedBox | null;
  disabled: boolean;
  onChange: (box: NormalizedBox) => void;
}) => {
  const [natural, setNatural] = useState<SourceSize | null>(null);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  // The recorded size when brian has one, else the loaded image's own.
  const size =
    still.width && still.height
      ? { width: still.width, height: still.height }
      : natural;

  return (
    <div className="flex flex-col gap-1">
      <StillFrame
        url={still.url}
        onLoad={setNatural}
        onError={() => setFailedUrl(still.url)}
      >
        {size && (
          <BoxOverlay
            size={size}
            tone="area"
            label="Person box"
            disabled={disabled}
            boxes={
              box
                ? [
                    {
                      key: "person",
                      box: fromNormalized(box, size),
                      label: "Person",
                    },
                  ]
                : []
            }
            onDraw={(drawn) => onChange(toNormalized(drawn, size))}
          />
        )}
      </StillFrame>
      {failedUrl === still.url && (
        <p className="text-sm text-ink-body">
          I couldn&rsquo;t load this still; its link may have expired. Press
          Refresh above to renew it, or remove it and choose another.
        </p>
      )}
    </div>
  );
};
